/**
 * Cultural Aspect List Component
 * Displays a list of cultural aspect items
 * Follows Single Responsibility Principle - only responsible for rendering the list
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { CulturalAspectItem } from './CulturalAspectItem';
import { CulturalAspect } from './types';

export interface CulturalAspectListProps {
  /**
   * Array of cultural aspects to display
   */
  items: CulturalAspect[];
}

/**
 * Cultural Aspect List Component
 * Renders a vertical list of cultural aspect items
 */
export const CulturalAspectList: React.FC<CulturalAspectListProps> = ({
  items,
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
    >
      {items.map(item => (
        <CulturalAspectItem key={item.id} aspect={item} />
      ))}
    </div>
  );
};
